<!-- PaperCuttingCanvas.vue -->
<template>

 
      <div class=" row container center">
        <div class="container center">
          <div class="flow-text left-align">
            <blockquote>Recuerda agregar tu medida con todo y su medianil.</blockquote>
          </div>
        </div>
        <div class="section center"> <canvas :width="canvasWidth" :height="canvasHeight" class="" ref="canvas"></canvas></div>
        <div class="row">
          <div class="" v-if="results">
            <p>Cortes por hoja: {{ results.cutsPerSheet }} |
            Área usada: <span>{{ results.usedPercentage }}</span>% |
            Área no usada: {{ results.unusedPercentage }}% |</p>
            <span v-show="result_text.length">Máximo de tamaños: </span>
            
            <ul v-show="result_text.length" class="collection">
              <li class="collection-item" v-for="(varitante, index) in result_text" :key="'vartiante-'+index">
                {{ varitante }}
              </li>
            </ul>
            
          </div>
        </div>
        <div class="row">
          <div class="opacity-display-anim " v-show="error" id="error-message">
            <span  class="red-text "> <i class="mdi mdi-alert"></i> {{ error }} </span>
          </div>
        </div>
        <div class=" row" @keyup="result_text=[]">
          <div class="row">
            <div class="input-group col s5">
              <label class="active">Ancho de papel (unidades):</label>
              <input v-model.number="paperWidth" type="number" min="1">
            </div>
            <div class="input-group col s5">
              <label class="active">Altura de papel (unidades):</label>
              <input v-model.number="paperHeight" type="number" min="1">
            </div>
            <div class="input-group col s2">
              <button class="btn-floating btn-small primary-btn" @click="turnPaper"><i
                  class="mdi mdi-swap-horizontal"></i></button>
            </div>
          </div>
          <div class="row">
            <div class="input-group col s5">
              <label class="active">Ancho de corte (unidades):</label>
              <input v-model.number="cutWidth" type="number" min="1">
            </div>
            <div class="input-group col s5">
              <label class="active">Alto de corte (unidades):</label>
              <input v-model.number="cutHeight" type="number" min="1">
            </div>
            <div class="input-group col s2">
              <button class="btn-floating btn-small primary-btn" @click="turnCut"><i
                  class="mdi mdi-swap-horizontal"></i></button>
            </div>
            
          </div>
          
         
          
        </div>
        <div class="row">

          <div class="input-group left col s4 offset-s3">
            <button class="waves-effect waves-light btn primary-btn" @click="findMaxCuts">Maximizar</button>
          </div>
        </div>

      </div>
   





  <footer class="page-footer ">
    <div class="footer-copyright">
      <div class="container center">
        © 2024 SOLTAR IMPRESORES S.A. DE C.V.
      </div>
    </div>
  </footer>
</template>

<script>
  import { ref, reactive, onMounted, watch } from 'vue';

  export default {
    name: 'PaperCuttingCanvas',
    setup() {
      const canvas = ref(null);
      const paperWidth = ref(195);
      const paperHeight = ref(115);
      const cutWidth = ref(55);
      const cutHeight = ref(95);
      const cut_orientation = ref('horizontal');
      const paper_orientation = ref('horizontal');
      const result_text = ref([]);
      const error = ref('');
      const results = reactive({
        cutsPerSheet: 0,
        usedPercentage: 0,
        unusedPercentage: 0
      });

      const canvasWidth = window.innerWidth*0.3333;
      const canvasHeight = window.innerHeight*0.3333;
      const scale = ref(1);

      const clearErrorMessageWithAnimation = () => {
        let error_div = document.getElementById('error-message');
        // make an anim with js
        error_div.animate([
          { opacity: 1 },
          { opacity: 0 }
        ], {
          duration: 333,

        }).onfinish = () => {
          error.value = '';
        }
        
      }

      const calcCutsPerSheet = (paperWidth, paperHeight, cutWidth, cutHeight) => {
        return Math.floor(paperWidth / cutWidth) * Math.floor(paperHeight / cutHeight);
      }

      const findMaxCuts = () => {
        /*
        TODO: find the combination that maximizes the cuts
        between cut_orientation and paper_orientation
        */
        result_text.value = [];
        let cuts_width_width = calcCutsPerSheet(paperWidth.value, paperHeight.value, cutWidth.value, cutHeight.value);
        let cuts_width_height = calcCutsPerSheet(paperWidth.value, paperHeight.value, cutHeight.value, cutWidth.value);
        let cuts_height_width = calcCutsPerSheet(paperHeight.value, paperWidth.value, cutWidth.value, cutHeight.value);
        let cuts_height_height = calcCutsPerSheet(paperHeight.value, paperWidth.value, cutHeight.value, cutWidth.value);
        let max_cuts = Math.max(cuts_width_width, cuts_width_height, cuts_height_width, cuts_height_height);



        if (cuts_width_width === max_cuts) {
          result_text.value.push(`Con el papel de ${paperWidth.value} de ancho por ${paperHeight.value} de alto y cortes de ${cutWidth.value}x${cutHeight.value} se obtiene un maximo de ${max_cuts} tamaños.`);
        }

        if (cuts_width_height === max_cuts) {
          result_text.value.push(`Con el papel de ${paperWidth.value} de ancho por ${paperHeight.value} de alto y cortes de ${cutHeight.value}x${cutWidth.value} se obtiene un maximo de ${max_cuts} tamaños.`);


        }

        if (cuts_height_width === max_cuts) {
          result_text.value.push(`Con el papel de ${paperHeight.value} ancho por ${paperWidth.value} de alto y cortes de ${cutWidth.value}x${cutHeight.value} se obtiene un maximo de ${max_cuts} tamaños.`);

        }

        if (cuts_height_height === max_cuts) {
          result_text.value.push(`Con el papel de ${paperHeight.value} de ancho por ${paperWidth.value} de alto y cortes de ${cutHeight.value}x${cutWidth.value} se obtiene un maximo de ${max_cuts} tamaños.`);

        }

        if (results.cutsPerSheet < max_cuts) {
          // verify if is necessary to turn cut
          if (cuts_width_height == max_cuts) {
            turnCut();
          }
          else if (cuts_height_width == max_cuts) {
            // turn paper
            turnPaper();
          }
          else if (cuts_height_height == max_cuts) {
            // turn paper
            turnPaper();
            turnCut();
          }
        }

        console.log(result_text.value);


      }
      const turnPaper = () => {
        let aux = paperHeight.value;
        paperHeight.value = paperWidth.value;
        paperWidth.value = aux;
      }
      const turnCut = () => {
        let aux = cutHeight.value;
        cutHeight.value = cutWidth.value;
        cutWidth.value = aux;
      }
      const drawPaperAndCuts = () => {
        if (!(paperHeight.value>0 && paperWidth.value>0 && cutHeight.value>0 && cutWidth.value>0)) {
          return;
        }
        if (paperWidth.value < cutWidth.value || paperHeight.value < cutHeight.value) {
          error.value='El papel debe ser mayor que el corte'
        }
        else {
          clearErrorMessageWithAnimation();
        }
        const ctx = canvas.value.getContext('2d');
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);

        // Calculate scale to fit paper on canvas
        scale.value = Math.min(
          canvasWidth / paperWidth.value,
          canvasHeight / paperHeight.value
        ) * 0.9; // 0.9 to leave some margin

        // Draw paper
        ctx.fillStyle = '#d0d0d0';

        ctx.fillRect(0, 0, paperWidth.value * scale.value, paperHeight.value * scale.value);

        // Calculate cuts
        let cutsPerRow, cutsPerColumn;

        cutsPerRow = Math.floor(paperWidth.value / cutWidth.value);
        cutsPerColumn = Math.floor(paperHeight.value / cutHeight.value);


        // Draw cuts
        ctx.fillStyle = 'rgba(255, 0, 0, 0.5)';
        for (let row = 0; row < cutsPerColumn; row++) {
          for (let col = 0; col < cutsPerRow; col++) {
            ctx.fillRect(
              col * cutWidth.value * scale.value,
              row * cutHeight.value * scale.value,
              cutWidth.value * scale.value - 1,
              cutHeight.value * scale.value - 1
            );
          }
        }

        // Calculate results
        results.cutsPerSheet = cutsPerRow * cutsPerColumn;
        const usedArea = results.cutsPerSheet * cutWidth.value * cutHeight.value;
        const totalArea = paperWidth.value * paperHeight.value;
        results.usedPercentage = ((usedArea / totalArea) * 100).toFixed(2);
        results.unusedPercentage = (100 - results.usedPercentage).toFixed(2);
      };

      onMounted(() => {
        drawPaperAndCuts();
      });

      watch([paperWidth, paperHeight, cutWidth, cutHeight, cut_orientation, paper_orientation], () => {
        drawPaperAndCuts();
      });

      return {
        canvas,
        paperWidth,
        paperHeight,
        cutWidth,
        cutHeight,
        results,
        canvasWidth,
        canvasHeight,
        findMaxCuts,
        calcCutsPerSheet,
        result_text,
        turnPaper,
        turnCut,
        error
      };
    }
  };
</script>

<style scoped>
  .controls {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
  }

  
  @keyframes entrar {
    from {
      opacity: 0%;
    }

    to {
      opacity: 100%;
    }
  }

  .opacity-display-anim {
    animation-name: entrar;
    animation-duration: 0.333s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
    
  }


</style>

